import 'reflect-metadata';
import {jsonObject, jsonMember, jsonArrayMember} from 'typedjson';

@jsonObject
export class LoraForwarder {

  @jsonMember
  public Id!: string;

  @jsonMember
  public Label!: string;

  @jsonMember
  public InfoComponent!: string;

  @jsonMember
  public Version!: string;

  @jsonMember
  public Group!: string;

  @jsonArrayMember(String)
  public Aliases!: string[];
}
